export interface ReferralModel {
    id: string;
    name: string;
}

export class ReferralConstants {
    static readonly Bndle = 'bndle';
    static readonly Bouwbeurs = 'Bouwbeurs';
    static readonly Workspotsolutions = 'Workspotsolutions';
    static readonly BWSbouw = 'BWSbouw';
    static readonly Levelupwerk = 'Levelupwerk';
}
